import { useEffect, useRef, useState } from "react";

export const useEffectDiff = (callBack, deps) => {
    // const {  } = props;
    const old = useRef(deps[0]);
    useEffect(() => {
        callBack(deps[0], old.current)
        old.current = deps[0];
    }, deps);
}